"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _ToggleButton = _interopRequireDefault(require("@mui/material/ToggleButton/ToggleButton.js"));
var _ToggleButtonGroup = _interopRequireDefault(require("@mui/material/ToggleButtonGroup/ToggleButtonGroup.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider/Divider.js"));
var _react2 = require("@tiptap/react");
var _textEditorButtons = require("./textEditorButtons");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const toggleLink = editor => {
  const url = window.prompt('Enter the URL');
  if (url === null) {
    return;
  }
  if (url.trim() === '') {
    editor.chain().focus().unsetLink().run();
    return;
  }
  const completeUrl = /^https?:\/\//i.test(url) ? url : `https://${url}`;
  editor.chain().focus().setLink({
    href: completeUrl
  }).run();
};
const BubbleMenu = () => {
  const editor = (0, _react2.useCurrentEditor)()?.editor;
  if (!editor) {
    console.error('Editor instance is not available.');
    return null;
  }
  const renderButtons = buttons => {
    return buttons.map(button => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      title: button.tooltip,
      arrow: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButton.default, {
        value: button.value,
        "aria-label": button.ariaLabel,
        onClick: () => {
          if (button.command === 'toggleLink') {
            toggleLink(editor);
          } else if (button.command === 'setTextAlign') {
            editor.chain().focus()[button.command](button.value.replace('align', '').toLowerCase()).run();
          } else {
            editor.chain().focus()[button.command](button.options || {}).run();
          }
        },
        selected: button.value.startsWith('heading') ? editor.isActive('heading', button.options || {}) : editor.isActive(button.value),
        sx: theme => ({
          border: 'none',
          '&.Mui-selected': {
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.light,
            color: theme.palette.primary.contrastText
          },
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300]
          }
        }),
        children: button.icon
      })
    }, button.value));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.BubbleMenu, {
    editor: editor,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      mb: 2,
      sx: theme => ({
        borderBottom: '1px solid',
        borderColor: editor.isFocused ? theme.palette.primary.main : theme.palette.grey[300],
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[50],
        borderRadius: '8px',
        boxShadow: theme.shadows[5],
        p: 1,
        width: 550,
        minWidth: '300px'
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButtonGroup.default, {
        value: "",
        "aria-label": "text formatting",
        exclusive: true,
        children: renderButtons(_textEditorButtons.formattingButtons)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
        orientation: "vertical",
        flexItem: true,
        sx: {
          mx: 1
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButtonGroup.default, {
        value: "",
        "aria-label": "alignment formatting",
        exclusive: true,
        children: renderButtons(_textEditorButtons.alignmentButtons)
      })]
    })
  });
};
var _default = exports.default = BubbleMenu;